import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { ProtectedRoute } from './components/ProtectedRoute';
import { AdminsPage } from './pages/AdminsPage';
import { CataloguesPage } from './pages/CataloguesPage';
import { DashboardPage } from './pages/DashboardPage';
import { EquivalenceRulesPage } from './pages/EquivalenceRulesPage';
import { ImportsPage } from './pages/ImportsPage';
import { LoginPage } from './pages/LoginPage';
import { ReleasesPage } from './pages/ReleasesPage';
import { RiddleFormPage } from './pages/RiddleFormPage';
import { RiddlesPage } from './pages/RiddlesPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="riddles" element={<RiddlesPage />} />
        <Route path="riddles/new" element={<RiddleFormPage />} />
        <Route path="riddles/:id" element={<RiddleFormPage />} />
        <Route path="imports" element={<ImportsPage />} />
        <Route path="equivalence-rules" element={<EquivalenceRulesPage />} />
        <Route path="releases" element={<ReleasesPage />} />
        <Route path="catalogues" element={<CataloguesPage />} />
        <Route path="admins" element={<AdminsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
